import { z } from "zod";
export const stemMutedPayloadSchema = z.object({
    sectionId: z.string().min(1),
    stem: z.string().min(1),
});
export const stemUnmutedPayloadSchema = z.object({
    sectionId: z.string().min(1),
    stem: z.string().min(1),
});
export const stemVolumeChangedPayloadSchema = z.object({
    sectionId: z.string().min(1),
    stem: z.string().min(1),
    volume: z.number().min(0).max(1),
});
/**
 * Materializes the result of a Demucs stem separation onto a section. Emitted
 * by the worker after the operational `StemsExtracted` event (which remains the
 * job's idempotency key / audit trail); this musical event is what the reducer
 * consumes to bind each stem's `assetHash` into the `AudioState`. Reuses the
 * `stemHashes` shape of `StemsExtracted` — the worker just forwards the map.
 */
export const sectionStemsBoundPayloadSchema = z.object({
    sectionId: z.string().min(1),
    stems: z
        .record(z.string().min(1), // stem name (drums, bass, vocals, …)
    z.string().regex(/^[0-9a-f]{64}$/))
        .refine((r) => Object.keys(r).length > 0, {
        message: "stems must contain at least one entry",
    }),
});
//# sourceMappingURL=stem.js.map